import { render, staticRenderFns } from "./PageDepartments.vue?vue&type=template&id=2c02c37e&"
import script from "./PageDepartments.vue?vue&type=script&lang=js&"
export * from "./PageDepartments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports